import { render, staticRenderFns } from "./ProductPage.vue?vue&type=template&id=a6d51e90&scoped=true&lang=html"
import script from "./ProductPage.vue?vue&type=script&lang=js"
export * from "./ProductPage.vue?vue&type=script&lang=js"
import style0 from "./ProductPage.vue?vue&type=style&index=0&id=a6d51e90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6d51e90",
  null
  
)

export default component.exports